import React, { useState } from 'react'
import { Modal, Button, Group, PasswordInput, Box } from '@mantine/core'
import { useForm, isNotEmpty } from '@mantine/form'
import { Toast } from '@ow/comps'
import { resetUserPwd } from '@vt/apis/lib-ex/v2/users'
import { getQuery, routeTo } from '@vt/utils'
import { useAppEx, useProjectStore } from '@vt/hooks'
import { pick } from 'lodash-es'
import { loginByLoginName as loginByLoginNameApi } from '@vt/apis/lib-ex/v2/login'

const RAP = process.env.REACT_APP_PROJECT
const Content = function () {
  const { appId } = useAppEx()
  const { userInfo, getVtProject } = useProjectStore((s) =>
    pick(s, ['userInfo', 'getVtProject'])
  )
  const { tpl } = getQuery()
  const vtProject = getVtProject()

  const [opened, setOpened] = useState(false)
  const form = useForm({
    initialValues: {
      oldPassword: '',
      password: '',
      rePassword: '',
    },

    validate: {
      oldPassword: isNotEmpty('请输入原始密码'),
      password: isNotEmpty('请输入新密码'),
      rePassword: isNotEmpty('请输入重复密码'),
    },
  })
  const onSubmit = async () => {
    const { oldPassword, password, rePassword } = form.values
    if (password !== rePassword) {
      form.setFieldError('rePassword', '两次密码输入不一致～ 请重新输入')
    } else {
      console.log(userInfo, 'userInfo')
      const { loginName, id } = userInfo
      // 检查输入的原始密码是否正确
      const res = await loginByLoginNameApi(loginName, oldPassword, true)
      console.log(res, 'denglu')
      let data = res
      try {
        data = JSON.parse(res)
      } catch (e) {
        console.log(data)
      }
      console.log(data, typeof data, 'errrorororo')
      if (
        data &&
        data.status !== 200 &&
        typeof data === 'object'
      ) {
        form.setFieldError('oldPassword', '原始密码输入错误～')
      } else {
        // 如果输入的原始密码正确，则开始修改密码
        resetUserPwd(appId, id, password).then(() => {
          setOpened(false)
          // 删除token，同时跳转到登录页
          vtProject.deleteStorage()
          routeTo(`/cp/${RAP}/login?key=${tpl}`)
          Toast.success({
            title: '修改成功',
          })
        })
      }
    }
  }
  return (
    <div>
      <p
        className="text-white font-size-sm cursor-pointer whitespace-nowrap"
        onClick={() => setOpened(true)}
      >
        修改密码
      </p>
      <Modal
        centered
        opened={opened}
        onClose={() => setOpened(false)}
        title="修改密码"
      >
        <Box maw={340} mx="auto">
          <form onSubmit={form.onSubmit((values) => onSubmit(values))}>
            <PasswordInput
              withAsterisk
              label="原始密码"
              {...form.getInputProps('oldPassword')}
            />
            <PasswordInput
              withAsterisk
              label="新密码"
              {...form.getInputProps('password')}
            />

            <PasswordInput
              withAsterisk
              label="重复密码"
              {...form.getInputProps('rePassword')}
            />
            <Group
              justify="flex-end"
              mt="md"
              style={{ justifyContent: 'flex-end' }}
            >
              <Button type="submit" style={{ background: '#276EE8' }}>
                确定
              </Button>
            </Group>
          </form>
        </Box>
      </Modal>
    </div>
  )
}
export default Content
